import { useEffect, useState } from 'react';
import { adminApi } from './adminApi';

export function usePricingEnabled() {
  const [pricingEnabled, setPricingEnabled] = useState(null); // null = loading
  useEffect(() => {
    adminApi.get('/settings/public')
      .then(({ data }) => setPricingEnabled(!!data.pricing_enabled))
      .catch(() => setPricingEnabled(true)); // fail open so a network hiccup never blocks real customers
  }, []);
  return pricingEnabled;
}
